import { untrack } from '@rehaje/reactive'

import { RR } from '../alias'

export function createQueue<T = any>() {
  let count = 0
  let queue: T[] = []
  return {
    add: (item: T) => {
      if (typeof item !== 'function') queue.push(item)
      else if (count === 0) item()
      else queue.push(RR.isInUntrack() ? untrack.bound(item) : item)
    },
    run: <U = any>(batch: () => U, effect: (queue: T[]) => void): U => {
      try {
        count++
        return batch()
      } finally {
        count--
        if (count === 0 && queue.length > 0) {
          const effectQueue = queue
          queue = []
          effect(effectQueue)
        }
      }
    }
  }
}
